import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'getYears'
})
export class GetYearsPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  getYearDiff(date1: Date | number | string, date2?: Date | number | string): number {
    const dateOne = moment(date1);
    const dateTwo = date2 ? moment(date2) : moment();
    return dateTwo.diff(dateOne, 'years');
  }

  toStringYears(years: number): string {
    const siYears = this.translate.instant('SI_YEARS');
    return `${years} ${siYears}`;
  }

  transform(date1: number | Date | string, date2?: number | Date | string): string {
    const years = this.getYearDiff(date1, date2);
    return this.toStringYears(years);
  }
}
